import React from 'react';
import PropTypes from 'prop-types';

import { Input } from 'moet-core';

import { removeNonDigitChars, turnInputIntoInteger, group } from './utils';

class IntegerInput extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    const {
      maxNumOfDigits = String(Number.MAX_SAFE_INTEGER).length,
      castToNumber = true,
      unsigned = false,
    } = this.props;
    const stripped = removeNonDigitChars(value, unsigned).slice(0, maxNumOfDigits);
    const finalValue = castToNumber ? turnInputIntoInteger(stripped, unsigned) : stripped;

    this.props.onChange(finalValue);
  }

  render() {
    const {
      onChange,
      value,
      castToNumber,
      unsigned,
      useGrouping,
      maxNumOfDigits,
      ...passDownProps
    } = this.props;
    const type = useGrouping || !castToNumber ? 'text' : 'number';
    const displayValue = useGrouping ? group(String(value)) : String(value);

    return <Input {...passDownProps} type={type} value={displayValue} onChange={this.onChange} />;
  }
}

IntegerInput.propTypes = {
  ...Input.propTypes,
  // if true, `onChange` will be called with a `Number` instead of a `String`
  castToNumber: PropTypes.bool,
  // when a string longer then `maxNumOfDigits` is received as `value`
  // it will be displayed until an `onChange` is triggered
  maxNumOfDigits: PropTypes.number,
  // flag to disallow/allow negative integers, allowed by default
  unsigned: PropTypes.bool,
  // flag to use thousands separator
  useGrouping: PropTypes.bool,
};

export { IntegerInput };
